import { getImageSrc } from '@captaincause/lib/getImageSrc'
import { tm } from '../tm'
import minidiftmanDelivery from '../assets/minidiftman-delivery.svg?inline'
import minidiftmanSmile from '../assets/minidiftman-smile.svg?inline'
import minidiftmanHat from '../assets/minidiftman-hat.svg?inline'
import minidiftmanZoom from '../assets/minidiftman-zoom.svg?inline'
import minidiftmanHappy from '../assets/minidiftman-happy.svg?inline'
import type { CSSProperties } from 'react'

export const MINIDIFTMEN_NAMES = [
  'delivery',
  'smile',
  'hat',
  'zoom',
  'happy',
] as const

export type MinidiftmanName = (typeof MINIDIFTMEN_NAMES)[number]

const MINIDIFTMEN: Record<MinidiftmanName, { image: string; bg: string }> = {
  delivery: { image: minidiftmanDelivery, bg: 'bg-red' },
  smile: { image: minidiftmanSmile, bg: 'bg-blue' },
  hat: { image: minidiftmanHat, bg: 'bg-green' },
  zoom: { image: minidiftmanZoom, bg: 'bg-purple' },
  happy: { image: minidiftmanHappy, bg: 'bg-orange' },
}

const SIZES = {
  normal: 'h-6 w-6',
  big: 'h-8 w-8',
}

export interface MinidiftmanProps {
  className?: string
  size?: keyof typeof SIZES
  style?: CSSProperties
  variant?: MinidiftmanName
}

const emptyObject = {}
export function Minidiftman({
  className = '',
  size = 'normal',
  style = emptyObject,
  variant = 'delivery',
}: MinidiftmanProps) {
  const diftman = MINIDIFTMEN[variant]

  return (
    <img
      src={getImageSrc(diftman.image)}
      alt=""
      width={24}
      height={24}
      className={tm('rounded-full', SIZES[size], diftman.bg, className)}
      style={style}
    />
  )
}
